module.exports = __webpack_public_path__ + "static/media/thunderstorm_audio.b6b5d294.mp4";